import { find, map } from 'lodash';

export const filterId = 'TimeRangeComparison';

export const _1_DAY_TIME_RANGE = {
    id: '1_DAY',
    name: '1 Day',
    durationInMinutes: 60 * 24,
};

export const _5_DAYS_TIME_RANGE = {
    id: '5_DAYS',
    name: '5 Days',
    durationInMinutes: 60 * 24 * 5,
};

export const _7_DAYS_TIME_RANGE = {
    id: '7_DAYS',
    name: '7 Days',
    durationInMinutes: 60 * 24 * 7,
};

export const _30_DAYS_TIME_RANGE = {
    id: '30_DAYS',
    name: '30 Days',
    durationInMinutes: 60 * 24 * 30,
};

export const TIME_RANGE_COMPARISON_PERIODS = [
    _1_DAY_TIME_RANGE,
    _5_DAYS_TIME_RANGE,
    _7_DAYS_TIME_RANGE,
    _30_DAYS_TIME_RANGE,
];
export const TIME_RANGE_COMPARISON_IDS = map(TIME_RANGE_COMPARISON_PERIODS, 'id');

export const DEFAULT_OPTIONS = {
    autoRefresh: true,
    enableCustom: true,
    alignToGranularity: true,
    timeRanges: TIME_RANGE_COMPARISON_PERIODS,
    minRangeMs: _1_DAY_TIME_RANGE.durationInMinutes * 60 * 1000,
    maxRangeMs: _30_DAYS_TIME_RANGE.durationInMinutes * 60 * 1000,
};

export const BEFORE_LABEL = 'Before Time Range';
export const AFTER_LABEL = 'After Time Range';
export const TIME_ZONE_LABEL = 'Time Zone';

export function getComparisonPeriod(id) {
    return find(TIME_RANGE_COMPARISON_PERIODS, { id });
}

export const title = 'Time Range Comparison';
export const MAX_FULL_RANGE_DAYS = 366;
export const MAX_FULL_RANGE_MS = MAX_FULL_RANGE_DAYS * 24 * 60 * 60 * 1000;
